import React, { useEffect, useState, useMemo } from 'react';
import { Row, Col } from 'antd';
import Wrapper from '../../../components/Wrapper';
import { CategoryCardV2 } from '../../../components/Cards';
import Typograpy from '../../../components/Typograpy';
import Diagramma from '../../../components/Diagramma';
import reports from '../../../services/reports';
import Spinner from '../../../components/Spinner';
import { useSelector } from 'react-redux';
import {
  makeReportAllgroups,
  makeReportBygroup,
  makeReportGrops,
} from '../../../utils/makeReport';
import SelectCategory from '../../../components/SelectCategory';
import RangePicker from '../../../components/RangePicker';

/* eslint react/no-unescaped-entities: off */
export default () => {
  const { selectedDate } = useSelector((state) => state.selectedDateReducer);
  const { categories, regions, groups, activeItem } = useSelector(
    (state) => state.appReducer
  );
  const { role } = useSelector((state) => state.authReducer);

  const parentCategories = categories.filter((item) => item.parent == null);
  const dateQuery = useMemo(
    () => selectedDate.every((item) => item !== '') && selectedDate,
    [selectedDate]
  );
  const [loading, setLoading] = useState(false);
  const [category, setCategory] = useState(null);
  const [groupReport, setgroupReport] = useState([]);
  const [reportData, setReportData] = useState([]);
  const [cardData, setCardData] = useState([]);

  const fetchReportBygroups = async (id) => {
    try {
      if (category !== null) {
        setLoading(true);
        const data = {
          start: selectedDate[0],
          end: selectedDate[1],
          group: id,
          category: category,
        };
        const { card, diogramma } = await reports.getGroupReport(data);
        const report = makeReportBygroup(diogramma, regions, category);
        const cards = makeReportGrops(card, categories);
        setCardData(cards);
        setgroupReport(report);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  const fetchAllReport = async () => {
    try {
      setLoading(true);
      const data = {
        start: selectedDate[0],
        end: selectedDate[1],
      };
      const reportsData = await reports.getAllgroupsReport(data);
      const report = makeReportAllgroups(reportsData, categories, groups);

      setReportData(report);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  useEffect(() => {
    if (
      role !== 'groupleader' &&
      activeItem == 'all' &&
      !selectedDate.every((item) => item === '')
    ) {
      fetchAllReport();
    }
    if (activeItem !== 'all' && !selectedDate.every((item) => item === '')) {
      fetchReportBygroups(activeItem);
    }
  }, [categories, groups, regions, dateQuery, category]);

  const handleCategory = (id) => {
    setCategory(id);
  };

  const filteredCategories = useMemo(
    () => parentCategories.filter((item) => item.group === activeItem),
    [activeItem]
  );
  useEffect(() => {
    if (activeItem !== 'all' && filteredCategories.length !== 0) {
      setCategory(filteredCategories[0]._id);
    }
  }, [filteredCategories]);

  if (loading) return <Spinner maxHeight={'100%'} />;
  return (
    <Wrapper>
      {activeItem == 'all' ? (
        <>
          <RangePicker />
          <Typograpy>
            Вилоятдаги барча гуруҳ раҳбарлари томонидан соҳалар кесимида <br />
            режалаштирилган ва бажарилган ишлар таҳлили
          </Typograpy>
          <Row align='middle' gutter={[20, 50]}>
            {reportData &&
              reportData?.map((item, indx) => (
                <Col
                  key={indx}
                  xs={24}
                  lg={12}
                  xl={12}
                  xxl={6}
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                  }}
                >
                  <CategoryCardV2 pageType='main' item={item} />
                </Col>
              ))}
          </Row>
        </>
      ) : (
        <>
          <Row gutter={[20, 16]}>
            <Col span={24}>
              <div style={{ width: '100%', margin: '50px 0' }}>
                <Typograpy>
                  Вилоятдаги барча гуруҳ раҳбарлари томонидан соҳалар кесимида{' '}
                  <br />
                  режалаштирилган ва бажарилган ишлар таҳлили
                </Typograpy>
              </div>
            </Col>
            <Col span={24}>
              <Row align='bottom' gutter={[20, 16]}>
                <Col xs={8} lg={12} xl={15} xxl={18}>
                  {filteredCategories.length !== 0 ? (
                    <SelectCategory
                      active={category}
                      options={filteredCategories}
                      handleChange={handleCategory}
                    />
                  ) : (
                    <Typograpy>
                      Ушбу гуруҳга категория бириктирилмаган
                    </Typograpy>
                  )}
                </Col>
                <Col span={6}>
                  <RangePicker direction='column' />{' '}
                </Col>
              </Row>
            </Col>
            <Col xs={8} lg={12} xl={15} xxl={18}>
              <Diagramma data={groupReport} />
            </Col>
            <Col span={6}>
              {cardData &&
                cardData?.map((item, indx) => (
                  <CategoryCardV2 key={`${indx + 1}`} item={item} />
                ))}
            </Col>
          </Row>
        </>
      )}
    </Wrapper>
  );
};
